import { Typography } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'

export const Title = () => {
  const { t } = useTranslation('web_ui')

  return (
    <Typography.Title level={5} marginBottom={16}>
      {t('contract_schedule.schedule')}
    </Typography.Title>
  )
}
